document.addEventListener('alpine:init', () => {
  Alpine.data('boxedText', () => ({
    maxHeight: 0,

    collapsed: false,

    bgColor: 'white',

    rootEl: {
      ':class'() {
        return {
          'text-boxed--collapsed': this.collapsed,
        };
      },
      ':style'() {
        return {
          '--bg-color': this.bgColor,
        };
      },
    },

    init() {
      this.maxHeight = +this.$root.dataset.maxHeight;
      this.$nextTick(() => this.calcHeight());
      this.resolveBgColor();
    },

    calcHeight() {
      if (this.maxHeight && this.$root.offsetHeight > this.maxHeight) {
        this.$root.style.maxHeight = this.maxHeight + 'px';
        this.collapsed = true;
      }
    },

    expand() {
      this.$root.style.maxHeight = null;
      this.collapsed = false;
    },

    resolveBgColor() {
      let parent = this.$root.parentElement;

      while (parent && parent.tagName !== 'BODY') {
        if (parent.style?.backgroundColor) {
          this.bgColor = parent.style.backgroundColor;
          break;
        }

        parent = parent.parentElement;
      }
    },
  }));
});